import type {RouteRecordRaw} from "vue-router";

import {route as linkRoute} from './link'

export const routeName = 'ExternalDoc';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'document',
    children: [
        linkRoute,
    ],
};